import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './hometext.css'; // Import the CSS file
import { Icon } from '@iconify/react/dist/iconify.js';

const HomeText = () => {
  const [showAdil, setShowAdil] = useState(false);
  const [showTitle, setShowTitle] = useState(false);
  const [showQuote, setShowQuote] = useState(false);

  useEffect(() => {
    // Show each text with a delay
    const timer1 = setTimeout(() => setShowAdil(true), 1000);
    const timer2 = setTimeout(() => setShowTitle(true), 2000);
    const timer3 = setTimeout(() => setShowQuote(true), 3000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, []);

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
    exit: { opacity: 0, y: -20, transition: { duration: 0.2 } },
  };

  return (
    <div className="flex justify-center flex-col items-center md:ps-16 " style={{ fontFamily: 'Chakra Petch' }}>
      {/* Software Developer */}
      {showTitle && (
        <motion.div
          className="flex flex-row justify-center items-center mt-5 md:ps-5 "
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={textVariants}
        >
          <div className="font-extrabold largertexts">
            <span className='text-gray-200 text-5xl '>I'M ADIL</span>
            <motion.div 
            initial={{ width: 0 }}
            animate={{ width: '183px' }}
            transition={{ duration: 1 }}
            className=' rounded h-0.5 bg-[#731cd7] mb-2'></motion.div> 
            <span className='md:text-7xl text-6xl text-purple-200 flex flex-row gap-1 items-center'><span className='opacity-85 styledText' style={{color: 'transparent'}}>DESIGNING </span> <span className='opacity-85 me-2 ms-2'>&</span><span className='opacity-85 styledText'style={{color: 'transparent'}}> DEVELOPING</span> </span>
           {/* <span className='opacity-50 md:text-7xl text-6xl text-purple-200 '> </span> */}
           <span className='md:text-7xl text-6xl text-purple-200 opacity-50 flex flex-row gap-1 items-center'><span>TOP-TIER WEB EXPERIENCES</span></span>
           {/* <span className='opacity-50 md:text-7xl text-6xl text-purple-200 '> TOP-TIER WEB EXPERIENCES</span> */}
           <span className='opacity-30 md:text-7xl text-6xl text-purple-200 '> WITH </span>
           <span className='md:text-7xl text-6xl text-purple-200 opacity-30 '>PRECISION & PASSION.</span>
          </div>

          <div className='smallScrTexts '>
          <span className='text-gray-200 text-4xl font-extrabold ps-2'>I'M ADIL</span>
            <motion.div 
            initial={{ width: 0 }}
            animate={{ width: '160px' }}
            transition={{ duration: 1 }}
            className=' rounded h-0.5 bg-purple-500 mb-5 ms-2'></motion.div> 
            <span className='text-gray-200 text-3xl font-extrabold '>DESIGNING & DEVELOPING</span>
            <br />
            <span className='text-gray-200 text-3xl font-extrabold'>TOP TIER WEB EXPERIENCES</span>
            <br />
            <span className='text-gray-200 text-3xl font-extrabold'>WITH PRECISION & PASSION.</span>
          </div>


        </motion.div>
      )}
    </div>
  );
};

export default HomeText;
